/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

import { initializeApp } from 'firebase/app';
import { navigate } from 'gatsby';
import React from 'react';
import { initializeServices } from 'src/services/initServices';
import App from './src/App';

export const onClientEntry = () => {
  initializeApp(JSON.parse(process.env.GATSBY_FIREBASE_CONFIG_KEY));
  initializeServices();
};

export const wrapRootElement = ({ element }) => {
  return <App element={element} />;
};

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (location && location.pathname !== prevLocation?.pathname) {
    window.scrollTo(0, 0);
  }

  // Handle signup route
  if (location.pathname === '/signup' && !location.pathname.endsWith('/welcome')) {
    // Use setTimeout to avoid potential race conditions with Gatsby's routing
    setTimeout(() => {
      navigate('/signup/welcome', { replace: true });
    }, 0);
  }
};
